import {Component, OnInit, ViewChild} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {Keepalive} from "@ng-idle/keepalive";
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {AuthService} from "./services/auth.service";
import {ModalDirective} from "ngx-bootstrap/modal";

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  @ViewChild('sessionExpirationModal') public sessionExpirationModal: ModalDirective;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  constructor(private router: Router,
              private authService: AuthService,
              private idle: Idle,
              private keepalive: Keepalive) {

    // sets an idle timeout of 5 seconds, for testing purposes.
    // idle.setIdle(5);
    idle.setIdle(900); // 15 minute timeout
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    // idle.setTimeout(5);
    idle.setTimeout(30);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      console.log(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Your session has timed out!';
      this.timedOut = true;
      console.log(this.idleState);
      // this.router.navigateByUrl('/logout');
      window.location.assign('/logout');
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
      console.log(this.idleState);
      this.sessionExpirationModal.show();

      // const modalRef = this.modalService.open(IdleTimeoutComponent);
      // modalRef.componentInstance.user = user;
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Your session will time out in ' + countdown + ' seconds!'
      console.log(this.idleState);
    });

    // sets the ping interval to 30 seconds
    keepalive.interval(30);
    keepalive.request("/ping");

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.authService.getLoginStatus().subscribe(data => {
      // console.log('updateLoginStatus.authService.getLoginStatus.data: ');
      // console.dir(data);
      if (data) {
        console.log('you are logged in...starting idle timer');
        this.reset();
      }
    });

    this.authService.session$.subscribe(data => {
      // console.log('updateLoginStatus.authService.getTest.data: ');
      // console.dir(data);
      if (data) {
        console.log('just logged in...starting idle timer');
        this.reset();
      }
    });

    // this.reset();

  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

}
